import React from 'react'
import ReactWOW from 'react-wow';

const  styles = {
    marginTop: '1rem',
    display: 'block'
}

export default class Question extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const answerList = []
        if (this.props.answerBulletList != undefined) {
            this.props.answerBulletList.forEach(answer => {
                answerList.push(<li>{answer}</li>)
            });

        }

        // const styles = {
        //      marginTop: '2 rem!important'
        // }
        return (
            <section className="analytices_list_area security_list_area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="hosting_title analytices_title">
                                <h2>{this.props.question}</h2>
                                <p>{this.props.answer}</p>
                            </div>
                            {this.props.questionTwo ? (<div style={styles}><p>{this.props.questionTwo}</p></div>) : null}
                            <ul className="analytices_list">
                                {answerList}
                            </ul>
                        </div>
                        <div className="col-lg-6">
                        <ReactWOW animation="fadeInRight" delay="0.3s">
                        <img className="feature_sketch wow fadeInRight" data-wow-delay="0.3s" style={{ width: '100%'}} src={this.props.imageSrc} alt={this.props.imgAlt? this.props.imgAlt: 'Cartoon'} />
                        </ReactWOW>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
